module.exports = __webpack_public_path__ + "img/pl-PL-add-to-google-wallet.61a3e3b.svg";